const normalizeEmail = email => email.replace(/(\+[^@]+)(?=@)/, '').toLowerCase();

export default normalizeEmail;
